module.exports = __webpack_public_path__ + "img/upload-file.4609fcf2.svg";